import React from "react";
import Select from "react-select";
import styles from "../editMedicalCertificate.module.scss";
import classNames from "classnames";

const ServiceDetails = ({ medicalCertificate, handleServiceChange, medicalCertificateFormData }) => {

    const pathologyStatus = [
        { value: "WNL", label: "WNL" },
        { value: "ABNL", label: "ABNL" },
        { value: "REACTIVE", label: "REACTIVE" },
        { value: "NON-REACTIVE", label: "NON-REACTIVE" },
        { value: "Add NewField", label: "Add NewField" },
    ];

    const radiologyStatus = [
        { value: "NORMAL", label: "NORMAL" },
        { value: "ABNORMAL", label: "ABNORMAL" },
    ];

    const combinedradiologyDetails = medicalCertificate?.radiologyDetails.map((item) => ({ ...item?.serviceDetails, radiologyResults: item.radiologyResults })).flat();

    return (
        <div className={classNames(styles.testAndProfile, "card")}>
            <div className="card-body">
                <div className={styles.testAndProfileWrapper}>
                    <div className="row">
                        {medicalCertificate && medicalCertificate?.testDetails?.map((item) => {
                            const currentTestItem = medicalCertificateFormData?.testDetails?.find(
                                (formItem) => formItem?.tests === item?.tests?._id
                            );
                            return (
                                <div className="col-md-4">
                                    <div className="form-group" key={item?.tests?._id}>
                                        <label className="col-form-label">{item?.tests?.testName}:</label>
                                        <Select
                                            name="testDetails"
                                            placeholder="Select Test Details"
                                            value={{ label: currentTestItem && currentTestItem?.testResults, value: currentTestItem && currentTestItem?.testResults }}
                                            onChange={(e) => handleServiceChange(e, "testDetails", item?.tests?._id)}
                                            options={
                                                pathologyStatus &&
                                                pathologyStatus?.map((serviceMode) => ({
                                                    value: serviceMode.value,
                                                    label: serviceMode.label,
                                                }))
                                            }
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    maxHeight: "14rem",
                                                    overflowY: "scroll",
                                                    position: 'absolute'
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                        {medicalCertificate && medicalCertificate?.profilesDetails?.map((item) => {
                            const currentProfiles = medicalCertificateFormData?.profilesDetails?.find(
                                (formItem) => formItem?.profiles === item?.profiles?._id
                            );
                            return (
                                <div className="col-md-4">
                                    <div className="form-group" key={item?.profiles?._id}>
                                        <label className="col-form-label">{item?.profiles?.profileName}:</label>
                                        <Select
                                            name="profilesDetails"
                                            placeholder="Select Profiles Details"
                                            value={{ label: currentProfiles && currentProfiles?.profileResults, value: currentProfiles && currentProfiles?.profileResults }}
                                            onChange={(e) => handleServiceChange(e, "profilesDetails", item?.profiles?._id)}
                                            options={
                                                pathologyStatus &&
                                                pathologyStatus?.map((serviceMode) => ({
                                                    value: serviceMode.value,
                                                    label: serviceMode.label,
                                                }))
                                            }
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    maxHeight: "14rem",
                                                    overflowY: "scroll",
                                                    position: 'absolute'
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                        {medicalCertificate && combinedradiologyDetails?.map((item) => {
                            const currentRadiology = medicalCertificateFormData?.radiologyDetails?.find(
                                (formItem) => formItem?.serviceDetails === item?._id
                            );
                            return (
                                <div className="col-md-4">
                                    <div className="form-group" key={item?._id}>
                                        <label className="col-form-label">{item?.serviceDetailsName}:</label>
                                        <Select
                                            name="radiologyDetails"
                                            placeholder="Please Radiology Details"
                                            value={{ label: currentRadiology && currentRadiology?.radiologyResults, value: currentRadiology && currentRadiology?.radiologyResults }}
                                            onChange={(e) => handleServiceChange(e, "radiologyDetails", item?._id)}
                                            options={
                                                radiologyStatus &&
                                                radiologyStatus?.map((serviceMode) => ({
                                                    value: serviceMode.value,
                                                    label: serviceMode.label,
                                                }))
                                            }
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    maxHeight: "14rem",
                                                    overflowY: "scroll",
                                                    position: 'absolute'
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceDetails;